/**
 * CartWarningModal.jsx
 * Created by michaelbray on 2/14/18.
 */

import React from 'react';
import moment from 'moment';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import * as Icons from '../../sharedComponents/icons/Icons';

const propTypes = {
    extendTimer: PropTypes.func.isRequired,
    fetchCart: PropTypes.func.isRequired,
    expiration: PropTypes.string,
    sessionWarning: PropTypes.bool
};

const defaultProps = {
    expiration: '',
    sessionWarning: false
};

export default class CartWarningModal extends React.Component {
    constructor(props) {
        super(props);

       const ignored = window.sessionStorage.getItem('r1s_cart_ignored') === "true";

        this.state = {
            timer: null,
            timeRemaining: 0,
            modalOpen: false,
            expired: false,
            ignored
        };

        this.tick = this.tick.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.extendTimer = this.extendTimer.bind(this);
        this.renderContent = this.renderContent.bind(this);
    }

    componentWillMount() {
        const timer = setInterval(() => this.tick(), 1000);
        this.setState({ timer });
    }

    componentWillUnmount() {
        clearInterval(this.state.timer);
    }

    tick() {
        this.setState({
            timeRemaining: -1 * moment().diff(this.props.expiration)
        });
        if (this.state.timeRemaining <= 0) {
            clearInterval(this.state.timer);
            this.setState({
                modalOpen: true,
                expired: true
            });
            window.sessionStorage.removeItem('r1s_cart_ignored');
            return;
        }
        if (this.state.timeRemaining <= 300000 && !this.state.ignored && !this.props.sessionWarning) {
            this.setState({ modalOpen: true });
        }
    }

    formatTime(num) {
        if (num <= 0) {
            return '00';
        }
        return num < 10 ? `0${num}` : num.toString();
    }

    closeModal(fetchCart) {
        this.setState({
            modalOpen: false,
            ignored: true
        });
        window.sessionStorage.setItem('r1s_cart_ignored', "true");
        if (fetchCart) {
            this.props.fetchCart();
        }
    }

    extendTimer() {
        this.props.extendTimer();
        this.closeModal();
    }

    renderTime() {
        const mm = this.formatTime(moment.duration(this.state.timeRemaining).get('minutes'));
        const ss = this.formatTime(moment.duration(this.state.timeRemaining).get('seconds'));

        return (
            <time>{mm}:{ss}</time>
        );
    }

    renderContent() {
        if (this.state.expired) {
            return (
                <div>
                    <div className="rec-modal-content-wrap">
                        <div>
                            <div className="rec-modal-title"><b>Your cart has expired.</b></div>
                            <p>The time ran out on your cart, and items have been removed. The good news is that we&#39;re still here, so let&#39;s retrace your steps or take a look for new adventures.</p>
                        </div>
                    </div>
                    <div className="rec-modal-actions-wrap">
                        <button className="rec-button-primary" title="Plan Your Trip" aria-label="Plan Your Trip Button" onClick={() => window.location.assign('/')}>
                            Plan Your Trip
                        </button>
                    </div>
                </div>
            );
        }
        return (
            <div>
                <div className="rec-modal-content-wrap">
                    <button
                        className="rec-close-modal"
                        onClick={this.closeModal}>
                        <Icons.IconClose />
                    </button>
                    <div className="rec-modal-title"><b>Your cart is about to expire.</b></div>
                    <p>This is a friendly reminder that your cart will time out in {this.renderTime()}. Once time is up, all items will be removed from your cart.</p>
                    <p>We can provide more time to finish this reservation, though! Would five more minutes be helpful?</p>
                </div>
                <div className="rec-modal-actions-wrap">
                    <button className="rec-button-primary" title="Extend Timer" aria-label="Extend Button" onClick={this.extendTimer}>
                        Add Five Minutes
                    </button>
                    <button className="rec-button-tertiary" title="Ignore" aria-label="Ignore Button" onClick={this.closeModal}>
                        Ignore
                    </button>
                </div>
            </div>
        );
    }

    render() {
        return (
            <Modal
                role="complementary"
                isOpen={this.state.modalOpen}
                className={{
                    base: 'rec-modal-dialog-base',
                    afterOpen: 'rec-modal-dialog-after-open-md',
                    beforeClose: 'rec-modal-dialog-before-close'
                }}
                overlayClassName={{
                    base: 'rec-overlay-base',
                    afterOpen: 'rec-overlay-after-open',
                    beforeClose: 'rec-overlay-before-close'
                }}
                contentLabel="Warning Modal"
                ariaHideApp={false}>
                {this.renderContent()}
            </Modal>
        );
    }
}

CartWarningModal.propTypes = propTypes;
CartWarningModal.defaultProps = defaultProps;
